<template>
  <div class="resetPassword xi">
    <nh-com></nh-com>
    <div class="startBox">
      <div class="startBoxCenter">
      <div class="" style="display: flex;justify-content: space-between;align-items: center;">
        <div class="banner-wrap">
          <div class=" " style="color: #666666; font-size: 16px"><router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>辨证论治</a><i class="el-icon-arrow-right"></i><a style="color: #666666">辨证论治系统</a></div>
        </div>
        <div style="color: #E07712;cursor: pointer;"  @click="toPage"><img src="../../assets/img/queImg/pcdx_back.png" alt="" style="margin-right: 5px;" srcset="">返回上一步</div>
      </div>
      <div  style="margin: 20px 0;position: relative;width: 105%;">
        <el-input class="searchInput" v-model="searchValue" placeholder="请输入内容..."  @keyup.enter.native="goSearchValue"> <i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
        <span style="position: absolute;top: 10px;right: 30px;font-size: 16px;color: #333333;cursor: pointer;" @click="goSearchValue">搜索</span>
      </div>
      <div class="startBoxleft">
            <div  style="display: flex; flex-wrap: wrap;gap: 13px;">
              <div class="wrapDiv" v-for="(item, index) in DiagnosiscategoryList1" :key="index">
                <div :class="Diagnosiscategoryindex == index ? 'goodTagCheck' : 'goodTag'" @click="gotextDiagnosis(item, index)">
                  {{ item.primarySymptomName }}<span v-if="item.diseaseDepartmentName" style="color:#E07712"> {{ '(' + item.diseaseDepartmentName  + ')' }}</span>
                </div>
              </div>
              <div class="wrapDiv">
                <div v-if="pageIndex1 < pageCount1" class="goodTag" @click="gotextDiagnosiMore1">更多...</div>
              </div>

            </div>
                        <div v-if="DiagnosiscategoryList1.length == 0" style="display: flex;justify-content: center;flex-direction: column;margin: auto;margin-top: 100px;width: 217px ;height: 120px">
              <img src="../../assets/img/queImg/nodata1.png" style="" alt="" srcset="">
              <span style="text-align: center;margin-top: 10px;">未搜索到该症状</span>
            </div>
          </div>
             <el-dialog modal title="提示" :visible.sync="dialogVisibleDetail" width="50%">
            <div class="dialogTitle">
              {{ selfDiagnosisPrimarySymptomDetail.primarySymptomName }}
            </div>
            <div class="textdetail" v-if="selfDiagnosisPrimarySymptomDetail.symptomDescription">
              <div class="" @click="handleRichClick">
                <p  v-html="richHtml"></p>
              </div>
            </div>
            <div class="startBtn2" @click="gostartSure"><span class="text">确定选择</span></div>
            <!-- <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleDetail = false">取 消</el-button>
              <el-button type="warning" @click="gostartSure">确 定</el-button>
            </span> -->
          </el-dialog>
                  <el-dialog
            title="图片预览"
            :visible.sync="dialogVisible"
            width="50%"
            append-to-body
            center
          >
            <div style="text-align:center;">
              <img :src="previewImgSrc" style="max-width:100%;max-height:100%;" />
            </div>
          </el-dialog>
    </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footerNew";
import nhCom from "../../components/header";
import { zdrugconsultationMain } from "../../components/zdrugconsultation/zdrugconsultation";
export default {
  name: "resetPassword",
  components: {
    ftCom,
    nhCom,
  },
  data() {
    var zdrugconsultation = new zdrugconsultationMain(this.TokenClient, this.Services.Disease);
    return {
      zdrugconsultationMain: zdrugconsultation,
      nam: "123",
      startShow: true,
      sexShow: false,
      sexName: "",
      sexShowName: "男",
      sexindex: 0,
      ageShow: false,
      ageName: "",
      ageShowName: "",
      ageindex: 1,
      sexList: [{ name: "男" }, { name: "女" }],
      showPrimarySymptomName: "",
      primarySymptomNameText: "",
      opcategoryindex: -1,
      centerDialogVisible: false,
      categoryList: [],
      categoryindex: -1,
      categoryList1: [],
      categoryindex1: -1,
      categoryList2: [],
      categoryindex2: -1,
      DiagnosiscategoryList: [],
      Diagnosiscategoryindex: -1,
      selfDiagnosisPrimarySymptomDetail: {},
      selfId: "",
      questindex: 0,
      questionList: [],
      processList: [],
      recordId: "",
      resultList: {},
      UserSelfDiagnosisRecordList: [],
      http: "",
      imgtextindex: -1,
      optionname: "",
      pageIndex: 1,
      pageCount: 1,
      selfDiagnosisId: "",
      searchDialogVisible: false,
      pageIndex1: 1,
      pageCount1: 1,
      DiagnosiscategoryList1: [],
      dialogVisibleDetail: false,
      searchValue: "",
      selfSex: "",
      selfAge: "",
      quename: "",
      selectAnswerUser: this.$route.query.selectAnswerUser,
            dialogVisible:false,
      previewImgSrc:''
    };
  },
  computed: {
  richHtml() {
  let html = this.selfDiagnosisPrimarySymptomDetail.description
  // 替换img，增加style，覆盖原width、height
  html = html.replace(/<img([^>]*)>/gi, (match, attr) => {
    return `<img${attr} style="max-width:100%;max-height:420px;width:auto!important;height:auto!important;">`
  })
  return html
}
  },
  mounted() {
    this.gosearchCategory();
    this.http = this.Services.Statics;
  },
  methods: {
              handleRichClick(e) {
      const target = e.target;
      if (target.tagName.toUpperCase() === "IMG") {
        this.previewImgSrc = target.src;
        this.dialogVisible = true;
      }
    },
    toPage(){
        this.$router.back()
    },
    gosearchCategory() {
      this.DiagnosiscategoryList1 = [];
      this.getSelfDiagnosisPrimarySymptomList1();
    },
    // 主症列表
    getSelfDiagnosisPrimarySymptomList1() {
      var _this = this;
      _this.pageIndex1 = 1;
      
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        0,
        "%20",
        JSON.parse( localStorage.getItem('selectAnswerUser2')).answerSex,
        JSON.parse( localStorage.getItem('selectAnswerUser2')).answerAge,
        _this.pageIndex1,
        function (data) {
          _this.DiagnosiscategoryList1 = data.data.results;
          _this.Diagnosiscategoryindex = -1;
          _this.pageCount1 = data.data.pageCount;
        },
        function (error) {
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList = [];
          }
        }
      );
    },
    goSearchValue() {
      var _this = this;
      let keyWord = "";
      if (_this.searchValue == "" || _this.searchValue == " ") {
        keyWord = "%20";
      } else {
        keyWord = _this.searchValue;
      }
      _this.pageIndex1 = 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        0,
        keyWord,
          JSON.parse( localStorage.getItem('selectAnswerUser2')).answerSex,
        JSON.parse( localStorage.getItem('selectAnswerUser2')).answerAge,
        _this.pageIndex1,
        function (data) {
          _this.DiagnosiscategoryList1 = data.data.results;
          _this.pageCount1 = data.data.pageCount;
          _this.Diagnosiscategoryindex = -1;
        },
        function (error) {
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList = [];
          }
        }
      );
    },
    gotextDiagnosiMore1() {
      var _this = this;
      let keyWord = "";
      if (_this.searchValue == "" || _this.searchValue == " ") {
        keyWord = "%20";
      } else {
        keyWord = _this.searchValue;
      }
      _this.pageIndex1 = _this.pageIndex1 + 1;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptom(
        0,
        keyWord,
        _this.pageIndex1,
        function (data) {
          _this.DiagnosiscategoryList1 = _this.DiagnosiscategoryList1.concat(data.data.results);
          _this.pageCount1 = data.data.pageCount;
        },
        function (error) {
          console.log(error);
          if (error.statusCode == 404) {
            _this.DiagnosiscategoryList1 = [];
          }
        }
      );
    },
    // 主症详情
    getSelfDiagnosisPrimarySymptomDetailList(e) {
      var _this = this;
      _this.zdrugconsultationMain.getSelfDiagnosisPrimarySymptomDetail(
        e,
        function (data) {
          _this.selfDiagnosisPrimarySymptomDetail = data.data;
          _this.selfSex = data.data.filterSex;
          _this.selfAge = data.data.minAge;
          _this.quename = data.data.primarySymptomName;
          _this.dialogVisibleDetail = true;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    gostartSure() {
 
      this.dialogVisibleDetail = false;
      this.$router.push({
        path: "/zdrugconsultation/zDrugProgress",
        query: {
          id: this.selfId,
          selectAnswerUser:JSON.parse( localStorage.getItem('selectAnswerUser2')),
          age: this.selfAge,
          sex: this.selfSex,
          name: this.quename,
        },
      });
    },
    gotextDiagnosis(item, index) {
      this.Diagnosiscategoryindex = index;
      this.showPrimarySymptomName = item.primarySymptomName;
      this.getSelfDiagnosisPrimarySymptomDetailList(item.id);
      this.selfId = item.id;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";
/* ::v-deep .el-dialog {
  width: 48% !important;
  margin-top: 20vh !important;
} */
.banner-wrap {
  /* position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto; */
}
.leftbox {
  display: flex;
  align-items: center;
}
.leftMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #f4f4f4;
  border-radius: 0px 15px 15px 15px;
  margin-left: 10px;
}
.resultMessage {
  width: 100%;
  margin-top: 15px;
  padding: 15px;
  margin-left: 10px;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 5px 10px 0px rgba(153, 153, 153, 0.16);
  border-radius: 16px;
}
.rightbox {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.rightMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #ee9e51;
  border-radius: 15px 0px 15px 15px;
  color: #fff;
}
.startBox {
  background: linear-gradient(180deg, #FFEFDE 0%, #F5F5F5 50%);
  /* border-radius: 19px; */
  padding: 30px;
  /* width: 1200px;
  margin: 30px auto;
  padding: 40px;
  box-shadow: 0px 6px 10px 0px rgba(204, 204, 204, 0.18);
  border-radius: 30px; */
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.startBoxCenter {
  width: 800px;
  margin: auto;
}
.startBoxleft {
  position: relative;
  width: 800px;
  min-height: 550px;
  max-height: 550px;
  background: #ffffff;
  border-radius: 30px;
  padding: 30px 20px;
  margin: auto;
  overflow-y: auto;
}
.startBoxleftTop {
  height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
/*滚动条样式*/
.startBoxleftTop::-webkit-scrollbar {
  width: 4px;
}
.startBoxleftTop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.startBoxleftTop::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.startBoxleftBot {
  /* overflow-x:scroll; */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 15px;
  border-top: 1px solid #e6e6e6;
  position: relative;
}
.startBoxleftBotn {
  margin-top: 12px;
  text-align: right;
  margin-right: 30px;
}
.surebtn {
  background: linear-gradient(180deg, #ffb163, #ee9e51);
  font-size: 16px;
  color: #ffffff;
  padding: 17rpx 0;
  width: 100%;
  text-align: center;
}
/* 症状 */
.textdetail {
    padding: 15px;
  /* background-color: #f2f2f2; */
  border-radius: 12px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
}
.viptable {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: auto;
}
.viptableY {
  width: 100%;
  height: 150px;
  overflow: hidden;
  overflow-y: auto;
}
.endbox {
  margin-top: -50px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
}
.endboxright {
  margin-top: 15px;
  padding: 10px 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
  cursor: pointer;
}
.flexlr {
  display: flex;
  justify-content: space-between;
}
.radioBox {
  margin: 10px 0;
  font-size: 18px;
}
.imgTag {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  margin-left: 10px;
  border-radius: 8px;
}
.imgTagCheck {
  background-color: #feaf62;
  /* opacity: 0.5; */
  padding: 5px;
}
.textCheck {
  color: #df7d1f;
}
.textBox {
  display: flex;
  flex-wrap: wrap;
}
.symptomsText {
  font-size: 15px;
  color: #666666;
  margin: 8px 0;
  padding-left: 22px;
  /* overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical; */
}
.itembox {
  width: 50%;
}
.nodataimg {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.hide-tooltip {
  max-width: 400px;
  /* visibility: hidden; */
}
.newChecked {
  color: #df7d1f;
}
.drugTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  padding-right: 40px;
  align-items: center;
}
.drugTitle1 {
  font-size: 28px;
  color: #333333;
}
.zdrugInputclass {
  width: 100%;
  padding: 10px 20px;
  background: #fafafa;
  border: 1px solid #e7a365;
  border-radius: 20px;
  font-size: 20px;
  color: #666666;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.zdrugInputIcon {
  padding: 7px 17px;
  border-radius: 17px;
  background-color: #e7a365;
  color: #fff;
}
.dialogTitle {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #F15C1A;
}
.flex-l-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.banner-right {

}
.banner-right span {
    display: inline-block;
    margin-left: 20px;
    width: 132px;
    height: 32px;
    border: 1px solid #333333;
    border-radius: 32px;
    box-sizing: border-box;
    text-align: center;
    color: #333333;
    line-height: 30px;
    cursor: pointer;
}

.banner-right span:hover {
    background-color: #ffffff;
    color: #00ab98;
}
.searchInput ::v-deep() .el-input__inner {
  border-radius: 20px;
  /* height: 50px;
  line-height: 50px; */
  background: #F4F6F7;
  border: none;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: #c2c2c2;
  border-radius: 3px;
}
.goodTagCheck {
  text-align: center;
  background: #FFF9F2;
  border-radius: 4px;
  font-size: 18px;
  color: #E07712;
  cursor: pointer;
  border: 1px solid #FFB066;
  /* width: 180px; */
  text-align: center;
  height: 44px;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 13px; */
  padding: 0 10px;
  box-sizing: border-box;   /* 关键 */
   /* width: 25%; */
   width: 100%;
}
.goodTag {
  width: 100%;
  font-size: 18px;
  background: #F1F1F1;
  color: #333333;
  border-radius: 4px;
  cursor: pointer;
  /* width: 180px; */
  height: 44px;
  text-align: center;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
   /* margin-right: 13px; */
   padding: 0 10px;
   box-sizing: border-box;   /* 关键 */
  /* width: 25%; */
}
.wrapDiv {
  width: calc((100% - 3 * 13px) / 4); /* 4个标签 + 3条间隙均分 */
  /* margin-top: 10px; */
}
.startBtn2 {
  color: #ffffff;
  padding: 10px 0;
  text-align: center;
  width: 500px;
  font-size: 16px;
  cursor: pointer;
  background: linear-gradient(270deg, #EEAB66, #EFC279);
  border-radius: 25px;
  margin: auto;
  margin-top:30px;
  margin-bottom:30px
}
</style>
<style>
.personal-center {
  display: none;
}
</style>
